interface HeartIconProps {
	color?: string;
}

export const HeartIcon: React.FC<HeartIconProps> = ({ color = "#212B36" }) => {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.8376 4.5C17.3836 4.49954 17.9243 4.6081 18.4278 4.81931C18.9314 5.03052 19.3877 5.34014 19.7701 5.73C20.5579 6.52979 20.9995 7.60737 20.9995 8.73C20.9995 9.85264 20.5579 10.9302 19.7701 11.73L12.0001 19.5975L4.23008 11.73C3.44226 10.9302 3.00067 9.85264 3.00067 8.73C3.00067 7.60737 3.44226 6.52979 4.23008 5.73C4.61264 5.34042 5.06901 5.03096 5.57251 4.81972C6.07601 4.60848 6.61656 4.49968 7.16258 4.49968C7.70859 4.49968 8.24914 4.60848 8.75264 4.81972C9.25614 5.03096 9.71251 5.34042 10.0951 5.73L12.0001 7.68L13.8976 5.745C14.2788 5.35049 14.7356 5.0369 15.2407 4.82298C15.7459 4.60906 16.289 4.49921 16.8376 4.5ZM16.8376 3C16.0918 2.99937 15.3534 3.14764 14.6657 3.43613C13.9779 3.72461 13.3547 4.1475 12.8326 4.68L12.0001 5.52L11.1676 4.68C10.6448 4.14846 10.0214 3.72631 9.33382 3.43814C8.64621 3.14998 7.90812 3.00157 7.16258 3.00157C6.41703 3.00157 5.67894 3.14998 4.99133 3.43814C4.30373 3.72631 3.68036 4.14846 3.15758 4.68C2.09398 5.76272 1.49805 7.21977 1.49805 8.7375C1.49805 10.2552 2.09398 11.7123 3.15758 12.795L12.0001 21.75L20.8426 12.795C21.9062 11.7123 22.5021 10.2552 22.5021 8.7375C22.5021 7.21977 21.9062 5.76272 20.8426 4.68C20.3199 4.14818 19.6966 3.72573 19.009 3.4373C18.3214 3.14886 17.5832 3.00021 16.8376 3Z"
				fill={color}
			/>
		</svg>
	);
};
